
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tppa2023",
      function () {
        return require("private-next-pages/tppa2023.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tppa2023"])
      });
    }
  